// extracted by mini-css-extract-plugin
module.exports = {"content":"Customization_content__o05El","submitBtn":"Customization_submitBtn__3QAmB"};